import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment.prod";
import {FeatureModulesAndPaths} from "../models/constants";

type feature = {
    featureName: string;
    featurePath: string;
};

@Injectable({
    providedIn: "root",
})
export class FeatureVisibilityControllerService {
    featureModuleFromConfig: any = environment.featuresVisibility;
    allFeaturesModules: feature[] = FeatureModulesAndPaths;

    constructor() {}

    isFeatureAllowed(featurePath: string | undefined): boolean {
        if (!featurePath) {
            return false;
        }
        const feature = this.allFeaturesModules.find((f) => f.featurePath === featurePath)?.featureName;
        if (!feature) {
            return false;
        }
        return this.featureModuleFromConfig[feature] || false;
    }

    isFunctionalityAllowed(featureName: string): boolean {
        return this.featureModuleFromConfig[featureName] || false;
    }
}
